import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { Article } from './article';

@JsonObject
export class Stock {
  constructor (
    id?: number,
    article?: Article,
    valeur?: number,
    stockDisponible?:boolean
  ) {
    this.id = id as any;
    this.article = article as any;
    this.valeur = valeur as any;
    this.stockDisponible = stockDisponible as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(Article)
  article: Article;

  @JsonProperty(Number)
  @Optional
  valeur?: number;

  @JsonProperty(Boolean)
  stockDisponible?: boolean;
}
